import { Stack, Box, Text, Tabs, TabList, Tab, TabPanels, TabPanel, Flex, Input, FormLabel, Select, Button, Textarea } from "@chakra-ui/react";
import 'services/Recruit/assets/css/CreateJobOpening/style.css';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { globalStyles } from "common/theme/styles";
import { AttachmentIcon } from "services/Recruit/assets/svg/AttachmentIcon";
import { Field, Formik, Form } from "formik";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { constant } from "common/constant";
import FileUpload from "common/components/fileUpload/FileUpload";
import ActionNavbar from "common/components/actionBar/ActionNavbar";
import { useDispatch, useSelector } from "react-redux";
import { jobProfileSchema } from "services/Recruit/schema/jobProfileSchema";
import { getDepartments } from "common/redux/reducers/departmentSlice";
import { fetchUserData } from "common/redux/reducers/userSlice";
import { addRecruitmentProfile } from "common/redux/reducers/recruitmentSlice";
import { uploadAttachment } from "common/redux/reducers/attachmentSlice";
import { CREATE_JOB_OPENING_INITIAL_VALUES } from "common/initialValues/formInitialValues";
import { candidateTabs } from "services/Recruit/data/candidate";
import { location } from "services/Recruit/data/candidate";
import { totalExperience } from "services/Recruit/data/candidate";
import { status } from "services/Recruit/data/candidate";
import { noiticPeriod } from "services/Recruit/data/candidate";
import { applicationSource } from "services/Recruit/data/candidate";
import { recruitConstant } from "services/Recruit/constant";

const CandidatesCreate= () => {
    const colors = globalStyles.colors;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const { users } = useSelector((state) => state.users);
    const handleTabChange = (index) => {
        setActiveTabIndex(index);
    };

    const handleNext = () => {
        if (activeTabIndex < 3) {
            setActiveTabIndex(activeTabIndex + 1);
        }
    };

    const handleBack = () => {
        if (activeTabIndex > 0) {
            setActiveTabIndex(activeTabIndex - 1);
        }
    }

    const handleFileChange = (dispatch, setFieldValue, fieldName) => (e) => {
        const file = e.target.files[0];
        if (file) {
            dispatch(uploadAttachment({ file, setFieldValue: (field, value) => setFieldValue(fieldName, value) }));
        }
    };

    useEffect(() => {
        dispatch(getDepartments());
        dispatch(fetchUserData());
    }, [dispatch]);

    return (
        <>
            <ActionNavbar
                isCreatePage={true}
            />
            <Stack>
                <Box className="createJobOpening-container">
                    <Box className='createJobOpening-mainContainer'>
                        <Box className='createJobOpening-breadCrumb'>
                            <ArrowBackIcon onClick={() => navigate("/recruit/candidates")} fontSize="20px" />
                            <Text className='createJobOpening-pageTitle'>{recruitConstant.createCandidates}</Text>
                        </Box>
                    </Box>

                    <Formik
                        initialValues={CREATE_JOB_OPENING_INITIAL_VALUES}
                        validationSchema={jobProfileSchema}
                        onSubmit={(values, { resetForm }) => {
                            dispatch(addRecruitmentProfile({ values, resetForm, navigate }));
                        }}
                    >
                        {({ values, setFieldValue, handleSubmit, errors, dirty, isValid, }) => (

                            <Form onSubmit={handleSubmit}>
                                <Tabs index={activeTabIndex} onChange={handleTabChange} className="createJobOpening-tabsContainer" variant="unstyled" orientation="vertical">
                                    {/* tab list  */}
                                    <TabList w={'40%'} className="createJobOpening-tabListContainer">
                                        {candidateTabs.map(({ label, Icon }, index) => (
                                            <Tab
                                                className="createJobOpening-tabs"
                                                key={index}
                                                _selected={{
                                                    color: colors.cta['100'],
                                                    borderLeft: "2px solid",
                                                    borderColor: colors.cta['100'],
                                                }}
                                                _hover={{
                                                    color: colors.cta['100'],
                                                }}
                                                _focus={{ boxShadow: "none" }}
                                                display="flex"
                                                alignItems="center"
                                                gap="8px"
                                            >
                                                <Icon size={20} />
                                                {label}
                                            </Tab>
                                        ))}
                                    </TabList>

                                    {/* tab panels */}
                                    <TabPanels w={'60%'} className="createJobOpening-tabsPanelContainer">

                                        {/* job opening tab */}
                                        <TabPanel className="createJobOpening-tabsPanel">

                                            <Box className="createJobOpening-tabsPanelBody">
                                                <Flex gap={'20px'}>
                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="title">{recruitConstant.name}<span className="astrick">*</span></FormLabel>
                                                        <Field name="title">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Input
                                                                        {...field}
                                                                        placeholder={recruitConstant.namePlaceHolderText}
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                    />
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="email">{recruitConstant.email}<span className="astrick">*</span></FormLabel>
                                                        <Field name="email">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Input
                                                                        {...field}
                                                                        placeholder={recruitConstant.emailPlaceHolderText}
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                    />
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                </Flex>

                                                <Flex gap={'20px'}>
                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="phone">{recruitConstant.phone}<span className="astrick">*</span></FormLabel>
                                                        <Field name="phone">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Input
                                                                        {...field}
                                                                        placeholder={recruitConstant.phonePlaceHolderText}
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                    />
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>

                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="location">{recruitConstant.location}<span className="astrick">*</span></FormLabel>
                                                        <Field name="location">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Select
                                                                        {...field}
                                                                        defaultValue=""
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                    >
                                                                        <option selected hidden value="">{recruitConstant.location}</option>
                                                                        {
                                                                            location.map((option) => (
                                                                                <option key={option._id} value={option._id}>
                                                                                    {option}
                                                                                </option>
                                                                            ))}
                                                                    </Select>
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                </Flex>

                                                <Flex gap={'20px'}>
                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="totalExperience">{recruitConstant.totalExperience}<span className="astrick">*</span></FormLabel>
                                                        <Field name="totalExperience">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Select
                                                                        {...field}
                                                                        defaultValue=""
                                                                        borderColor={meta.touched && meta.error ? constant.errorText : constant.borderColor}
                                                                    >
                                                                        <option selected hidden value="">{recruitConstant.totalExperience}</option>
                                                                        {
                                                                            totalExperience.map((option) => (
                                                                                <option key={option._id} value={option._id}>
                                                                                    {option}
                                                                                </option>
                                                                            ))}
                                                                    </Select>
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>

                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="currentLocation">{recruitConstant.currentLocation}<span className="astrick">*</span></FormLabel>
                                                        <Field name="currentLOcation">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Input
                                                                        {...field}
                                                                        placeholder={recruitConstant.currentLocation}
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                    />
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                </Flex>

                                                <Flex gap={'20px'}>
                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="noticePeriod">{recruitConstant.noticePeriod}<span className="astrick">*</span></FormLabel>
                                                        <Field name="noticePeriod">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Select
                                                                        {...field}
                                                                        defaultValue=""
                                                                        borderColor={meta.touched && meta.error ? constant.errorText : constant.borderColor}
                                                                    >
                                                                        <option selected hidden value="">{recruitConstant.noticePeriod}</option>
                                                                        {
                                                                            noiticPeriod.map((option) => (
                                                                                <option key={option._id} value={option._id}>
                                                                                    {option}
                                                                                </option>
                                                                            ))}
                                                                    </Select>
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>

                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="status">{recruitConstant.status}<span className="astrick">*</span></FormLabel>
                                                        <Field name="status">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Select
                                                                        {...field}
                                                                        defaultValue=""
                                                                        borderColor={meta.touched && meta.error ? constant.errorText : constant.borderColor}
                                                                    >
                                                                        <option selected hidden value="">{recruitConstant.status}</option>
                                                                        {
                                                                            status.map((option) => (
                                                                                <option key={option._id} value={option._id}>
                                                                                    {option}
                                                                                </option>
                                                                            ))}
                                                                    </Select>
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                </Flex>
                                                <Flex gap={'20px'}>
                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="applicationSource">{recruitConstant.applicationSource}<span className="astrick">*</span></FormLabel>
                                                        <Field name="applicationSource">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Select
                                                                        {...field}
                                                                        defaultValue=""
                                                                        borderColor={meta.touched && meta.error ? constant.errorText : constant.borderColor}
                                                                    >
                                                                        <option selected hidden value="">{recruitConstant.applicationSource}</option>
                                                                        {
                                                                            applicationSource.map((option) => (
                                                                                <option key={option._id} value={option._id}>
                                                                                    {option}
                                                                                </option>
                                                                            ))}
                                                                    </Select>
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                </Flex>
                                            </Box>

                                            <Box className="createJobOpening-tabsPanelFooter">
                                                <Button className="backBtn" variant="primary" onClick={() => navigate("/recruit/candidates")}>
                                                    {recruitConstant.back}
                                                </Button>
                                                <Button className="nextBtn" variant="primary" onClick={handleNext}>{recruitConstant.next}</Button>
                                            </Box>

                                        </TabPanel>
                                        <TabPanel className="createJobOpening-tabsPanel">

                                            <Box className="createJobOpening-tabsPanelBody">
                                                <Flex gap={'20px'}>
                                                    <Box w={'100%'}>
                                                        <Field name="jobSummaryAttachment">
                                                            {({ field, form, meta }) => (
                                                                <FileUpload
                                                                    label={recruitConstant.CoverLetter}
                                                                    icon={AttachmentIcon}
                                                                    selectedFile={field.value}
                                                                    title={recruitConstant.attachment}
                                                                    inputId="job-summary-upload"
                                                                    handleFileChange={handleFileChange(dispatch, form.setFieldValue, "jobSummaryAttachment")}
                                                                    errorText={meta.touched && meta.error ? meta.error : ""}
                                                                    type="file"
                                                                    borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                    accept="audio/*,video/*,image/*,application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                                                                />
                                                            )}
                                                        </Field>
                                                    </Box>
                                                </Flex>
                                            </Box>

                                            <Box className="createJobOpening-tabsPanelFooter">
                                                <Button className="backBtn" variant="primary" onClick={() => navigate("/recruit/candidate")}>
                                                    {constant.back}
                                                </Button>
                                                <Button
                                                    className="nextBtn"
                                                    variant="primary"
                                                    type="submit"
                                                    onClick={() => navigate("/recruit/candidates")}
                                                >
                                                    {id ? recruitConstant.update : recruitConstant.save}
                                                </Button>
                                            </Box>

                                        </TabPanel>
                                    </TabPanels>
                                </Tabs>
                            </Form>
                        )}
                    </Formik>
                </Box>
            </Stack>
        </>
    );
};

export default CandidatesCreate;
